export default __webpack_public_path__ + "static/media/exclamation-mark.b1235b90.svg";